var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add_link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 9.5H16V11.5H8V9.5ZM20.1 10.5H22C22 7.74 19.76 5.5 17 5.5H13V7.4H17C18.71 7.4 20.1 8.79 20.1 10.5ZM3.9 10.5C3.9 8.79 5.29 7.4 7 7.4H11V5.5H7C4.24 5.5 2 7.74 2 10.5C2 13.26 4.24 15.5 7 15.5H11V13.6H7C5.29 13.6 3.9 12.21 3.9 10.5ZM19 10.5H17V13.5H14V15.5H17V18.5H19V15.5H22V13.5H19V10.5Z",
    fill: "#343333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLink);
export default __webpack_public_path__ + "static/media/add-link.7952a92df5bf6a32be29fe2ce964659b.svg";
export { ForwardRef as ReactComponent };